import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledHead = styled.div`
	position: relative;
	height: 41px;
	padding: 0 20px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);

	${Text} {
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		font-size: 18px;
		font-weight: 500;
		color: #ffffff;
	}
`;

const StyledContainer = styled.div`
	padding: 20px;
`;

const StyledSearchWrapper = styled.div<{ $active: boolean }>`
	position: relative;

	img {
		position: absolute;
		top: 50%;
		right: 15px;
		transform: translateY(-50%);
		width: 14px;
		height: 14px;
		opacity: 0.5;
		transition:
			opacity 0.3s ease,
			filter 0.3s ease;
		user-select: none;
		pointer-events: none;
	}

	${({ $active }) =>
		$active &&
		css`
			img {
				opacity: 1;
			}
		`}

	&:hover {
		img {
			opacity: 1;
			filter: invert(1);
		}
	}
`;

const StyledSearchInput = styled.input<{ $active: boolean }>`
	width: 100%;
	height: 50px;
	padding: 0 44px 0 15px;
	background-color: rgba(255, 255, 255, 0.1);
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 16px;
	color: #ffffff;
	transition:
		color 0.3s ease,
		background-color 0.3s ease;
	outline: none;
	border: none;
	border-radius: 10px;

	&::placeholder {
		color: rgba(255, 255, 255, 0.25);
		transition: color 0.3s ease;
		user-select: none;
	}

	${({ $active }) =>
		$active &&
		css`
			background-color: #2d70da;
			color: #ffffff;
		`}

	&:hover {
		background-color: #ffffff;
		color: #000000;

		&::placeholder {
			color: rgba(0, 0, 0, 0.5);
		}
	}
`;

const StyledPlayersList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	height: 350px;
	overflow-y: scroll;
	margin-top: 20px;

	&::-webkit-scrollbar {
		display: none;
	}
`;

export {
	StyledContainer,
	StyledHead,
	StyledPlayersList,
	StyledSearchInput,
	StyledSearchWrapper,
};
